<template>
  <o-table :title="$t('offer.products')" url="/api/products" ref="tableList">
    <template slot="filter">       
    </template>  
    <template slot="head">
      <o-table-header column="gtin">{{$t('offer.gtin')}}</o-table-header>
      <o-table-header column="product">{{$t('offer.product')}}</o-table-header>
      <o-table-header column="package">{{$t('offer.package')}}</o-table-header>
      <o-table-header column="package">{{$t('offer.efp')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.gtin }}</td>
      <td>{{ props.item.product }}</td>
      <td>{{ props.item.package }}</td>
      <td>{{ props.item.efp | formatNumber }}</td>
    </template>
  </o-table>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
  },
  computed: mapGetters({
    locale: 'lang/locale',
    user: 'auth/user'
  }),
}
</script>